import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  IconButton,
  Typography,
} from "@mui/material";
import StorefrontIcon from "@mui/icons-material/Storefront";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PersonIcon from "@mui/icons-material/Person";
import CloseIcon from "@mui/icons-material/Close";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import React, { useState } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import axios from "axios";
import { endPoint } from "../../global";
import { useAuth } from "../../context/AuthProvider";

const poppins = { fontFamily: "'Poppins', sans-serif" };

const InfoRow = ({ icon, label, value }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      gap: 2,
      backgroundColor: "rgba(255,255,255,0.7)",
      border: "1px solid rgba(255,255,255,0.9)",
      borderRadius: "12px",
      px: 2.5,
      py: 1.8,
      mb: 1.5,
    }}
  >
    <Box sx={{ color: "#1e3a6e", flexShrink: 0 }}>{icon}</Box>
    <Box>
      <Typography
        sx={{
          ...poppins,
          fontSize: "0.72rem",
          color: "rgba(15,31,69,0.5)",
          fontWeight: 400,
          lineHeight: 1.2,
        }}
      >
        {label}
      </Typography>
      <Typography
        sx={{
          ...poppins,
          fontSize: "0.95rem",
          color: "#0f1f45",
          fontWeight: 600,
        }}
      >
        {value}
      </Typography>
    </Box>
  </Box>
);

export default function Profile() {
  const { user } = useOutletContext();
  const { token } = useAuth();
  const navigate = useNavigate();
  console.log(user);

  const [checking, setChecking] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  const handleOfferClick = async () => {
    setChecking(true);
    try {
      const res = await axios.get(endPoint + "offer", {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.data.msg) {
        setModalOpen(true);
      } else {
        navigate("/offer");
      }
    } catch (error) {
      navigate("/offer");
    } finally {
      setChecking(false);
    }
  };

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      sx={{ flex: 1, px: 3, py: 2, zIndex: 1, position: "relative" }}
    >
      {/* Logo */}
      <img
        src="SolarTuffNatGath.png"
        alt="Solartuff NatGath"
        style={{ width: 260, objectFit: "contain" }}
      />
      <img
        src="Theme Title.png"
        alt="Strength of Loyalty & Relationships"
        style={{ width: 260, objectFit: "contain", marginBottom: 8 }}
      />

      {/* Greeting */}
      <Typography
        sx={{
          ...poppins,
          fontWeight: 700,
          fontSize: "1.5rem",
          color: "#fff",
          mb: 0.5,
        }}
      >
        Selamat Datang!
      </Typography>
      <Typography
        sx={{
          ...poppins,
          fontWeight: 400,
          fontSize: "0.85rem",
          color: "rgba(255,255,255,0.75)",
          mb: 2,
        }}
      >
        Berikut informasi akun Anda
      </Typography>

      {/* Info card */}
      <Box
        sx={{
          width: "100%",
          maxWidth: 420,
          backgroundColor: "rgba(255,255,255,0.15)",
          border: "1px solid rgba(255,255,255,0.4)",
          borderRadius: "20px",
          p: 3,
          mb: 3,
          backdropFilter: "blur(16px)",
        }}
      >
        <InfoRow
          icon={<PersonIcon />}
          label="Nama Pemilik"
          value={user[0].name}
        />
        <InfoRow
          icon={<StorefrontIcon />}
          label="Nama Toko"
          value={user[0].storeName}
        />
        <InfoRow icon={<LocationOnIcon />} label="Area" value={user[0].area} />
      </Box>

      {/* CTA Button */}
      <Box sx={{ width: "100%", maxWidth: 420 }}>
        <Button
          variant="contained"
          fullWidth
          onClick={handleOfferClick}
          disabled={checking}
          sx={{
            ...poppins,
            background: "#1e3a6e",
            borderRadius: "14px",
            py: 1.8,
            fontSize: "1rem",
            fontWeight: 700,
            textTransform: "none",
            boxShadow: "0 6px 24px rgba(15,31,69,0.4)",
            "&:hover": { background: "#162d57" },
            "&.Mui-disabled": {
              background: "rgba(255,255,255,0.2)",
              color: "rgba(15,31,69,0.4)",
            },
          }}
        >
          {checking ? (
            <CircularProgress
              size={20}
              sx={{ color: "rgba(255,255,255,0.5)" }}
            />
          ) : (
            "Penawaran Spesial"
          )}
        </Button>
      </Box>

      {/* Already purchased modal */}
      <Dialog
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            background: "linear-gradient(180deg, #091b3d 0%, #060f24 100%)",
            border: "1px solid rgba(255,255,255,0.1)",
            borderRadius: "20px",
          },
        }}
      >
        {/* Header */}
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          px={3}
          py={2}
          sx={{ borderBottom: "1px solid rgba(255,255,255,0.08)" }}
        >
          <Box display="flex" alignItems="center" gap={1}>
            <InfoOutlinedIcon
              sx={{ color: "rgba(147,197,253,0.8)", fontSize: 20 }}
            />
            <Typography
              sx={{
                ...poppins,
                fontWeight: 700,
                fontSize: "1rem",
                color: "#fff",
                textShadow: "0 0 16px rgba(96,165,250,0.5)",
              }}
            >
              Informasi
            </Typography>
          </Box>
          <IconButton
            onClick={() => setModalOpen(false)}
            sx={{ color: "rgba(186,230,253,0.7)" }}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        <DialogContent sx={{ px: 3, py: 3, textAlign: "center" }}>
          {/* Icon */}
          <Box
            sx={{
              width: 64,
              height: 64,
              borderRadius: "50%",
              background: "rgba(37,99,235,0.15)",
              border: "1px solid rgba(96,165,250,0.3)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mx: "auto",
              mb: 2,
            }}
          >
            <InfoOutlinedIcon sx={{ fontSize: 32, color: "#60a5fa" }} />
          </Box>

          <Typography
            sx={{
              ...poppins,
              fontWeight: 700,
              fontSize: "1rem",
              color: "#fff",
              mb: 1,
            }}
          >
            Pembelian Sudah Dilakukan
          </Typography>
          <Typography
            sx={{
              ...poppins,
              fontSize: "0.85rem",
              color: "rgba(186,230,253,0.65)",
              lineHeight: 1.6,
            }}
          >
            Anda sudah melakukan pembelian. Silakan hubungi panitia jika ada
            pertanyaan.
          </Typography>
        </DialogContent>

        <Box px={3} pb={3}>
          <Button
            onClick={() => setModalOpen(false)}
            variant="contained"
            fullWidth
            sx={{
              ...poppins,
              background: "linear-gradient(135deg, #1d4ed8 0%, #2563eb 100%)",
              borderRadius: "12px",
              py: 1.4,
              fontSize: "0.9rem",
              fontWeight: 700,
              textTransform: "none",
              boxShadow: "0 6px 24px rgba(37,99,235,0.4)",
              "&:hover": {
                background: "linear-gradient(135deg, #1e40af 0%, #1d4ed8 100%)",
              },
            }}
          >
            Tutup
          </Button>
        </Box>
      </Dialog>
    </Box>
  );
}
